import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, } from 'reactstrap';
import { Container, Draggable } from 'react-smooth-dnd';
import { arrayMoveImmutable } from 'array-move';

import { batch, } from '../../shared/firebase';
import firebase from '../../firebase';

const db = firebase.firestore();

// NOTE: 会社の並び替え専用モーダル。
// マッピング表（O(N²)描画）から並び替えを切り離し、子会社数が増えても
// ドラッグ操作が軽量に動くようにするためのもの。
export default function SubsidiariesSortModal(props) {
  const { company, subsidiaries, onClickClose, ...extraProps } = props;
  const onDrop = async ({ addedIndex, removedIndex }) => {
    const newIds = arrayMoveImmutable(subsidiaries, removedIndex, addedIndex).map(_ => _.id);
    await batch(db, newIds, (batch, id, index) => {
      batch.update(company.ref.collection('subsidiaries').doc(id), { index });
    });
  };

  return (
    <Modal toggle={onClickClose} {...extraProps}>
      <ModalHeader>
        連結子会社の並び替え
      </ModalHeader>
      <ModalBody>
        {
          subsidiaries.length > 0 ? (
            <Container
              dragHandleSelector=".drag-handle"
              onDrop={onDrop}
              dropPlaceholder={{ style: { background: 'eee', } }}
              render={(ref) => (
                <div ref={ref} className="card">
                  {
                    subsidiaries.map((subsidiary) => {
                      return (
                        <Draggable key={subsidiary.id}>
                          <div className="d-flex align-items-center gap-2 p-2 border-bottom bg-white">
                            <div className="drag-handle text-muted cursor-move px-1">
                              <span className="fas fa-grip-vertical" />
                            </div>
                            <div>
                              {subsidiary.display_name}
                            </div>
                          </div>
                        </Draggable>
                      );
                    })
                  }
                </div>
              )}
            />
          ) : (
            <div>
              連結子会社は未登録です
            </div>
          )
        }
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
}
